import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class PauseForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Pause the flow. If this is the first action in your flow, the user will hear a dial-tone
          whilst paused.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          label="Duration"
          name="length"
          component={Input}
          type="number"
          validate={[vRequired]}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Pause/PauseForm.jsx